export default __webpack_public_path__ + "static/media/audiences-icon.2aaf3f16.svg";